import React from "react";

export const SectionHeader = () => {
  return (
    <section
      id="section-meet-you-there"
      className="relative bg-cream w-full px-6 sm:px-10 lg:px-16 pt-28 sm:pt-36 lg:pt-40 pb-16 sm:pb-20"
      data-testid="section-header"
    >
      <div className="max-w-prose3 mx-auto">
        <h2
          className="display-serif text-nearblack text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-8 sm:mb-10"
          data-testid="section-header-headline"
        >
          Wherever you are in the work, we meet you there.
        </h2>
        <p
          className="font-body text-base sm:text-lg leading-relaxed text-nearblack/75 max-w-prose2"
          data-testid="section-header-subline"
        >
          The path from idea to produced script isn't linear. Some days you're stress-testing
          a premise. Others, you're polishing dialogue for a coverage meeting. Voxium Script
          is built to meet you at each stage, with the right kind of reader at the right
          moment.
        </p>
      </div>
    </section>
  );
};

export default SectionHeader;
